module.exports = __webpack_public_path__ + "static/chocolate_flower-fd7b9d37f808366edd218857037fdee3.jpg";